"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.entriesToObject = void 0;
var tslib_1 = require("tslib");
var arrayToObject_1 = require("./arrayToObject");
function entriesToObject(obj) {
    return arrayToObject_1.arrayToObject(obj, function (_a) {
        var _b;
        var _c = tslib_1.__read(_a, 2), key = _c[0], val = _c[1];
        return (_b = {}, _b[key] = val, _b);
    });
}
exports.entriesToObject = entriesToObject;
//# sourceMappingURL=entriesToObject.js.map